import styled from 'styled-components';
import Button from '../Button/Button';

export default styled(Button)`
  background-color: #ffffff !important;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  color: var(--color-global-black) !important;
  width: auto;
  padding-left: 0;
  padding-right: 0;
`;
